/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedUnitCostDtoPage } from '../../models/planned-unit-cost-dto-page';

export interface ListPlannedUnitCosts$Params {
  budgetId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'units' | '-units' | 'comment' | '-comment' | 'amount' | '-amount' | 'isCalculated' | '-isCalculated' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'unitCost' | '-unitCost' | 'budget' | '-budget'>;
}

export function listPlannedUnitCosts(http: HttpClient, rootUrl: string, params?: ListPlannedUnitCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listPlannedUnitCosts.PATH, 'get');
  if (params) {
    rb.query('budgetId', params.budgetId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedUnitCostDtoPage>;
    })
  );
}

listPlannedUnitCosts.PATH = '/v0/plannedUnitCosts';
